import React from "react";

function SvgCalendar({ className }) {
  return (
    <svg
      className={`${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 2.5H15V0.46875C15 0.209883 14.7901 0 14.5312 0H12.9688C12.7099 0 12.5 0.209883 12.5 0.46875V2.5H7.5V0.46875C7.5 0.209883 7.29012 0 7.03125 0H5.46875C5.20988 0 5 0.209883 5 0.46875V2.5H3.125C2.08945 2.5 1.25 3.33945 1.25 4.375V18.125C1.25 19.1605 2.08945 20 3.125 20H16.875C17.9105 20 18.75 19.1605 18.75 18.125V4.375C18.75 3.33945 17.9105 2.5 16.875 2.5ZM16.6406 18.125H3.35938C3.29721 18.125 3.2376 18.1003 3.19365 18.0564C3.14969 18.0124 3.125 17.9528 3.125 17.8906V4.7H16.875V17.8906C16.875 17.9528 16.8503 18.0124 16.8064 18.0564C16.7624 18.1003 16.7028 18.125 16.6406 18.125Z"
        fill="currentColor"
      />
      <path
        d="M9.01729 15.8015L14.5762 10.2871C14.76 10.1048 14.7612 9.80803 14.5789 9.62424L13.6986 8.73682C13.5163 8.55303 13.2195 8.55186 13.0357 8.73417L8.69694 13.0381L6.97412 11.3014C6.79182 11.1175 6.49502 11.1164 6.31123 11.2987L5.42377 12.179C5.23998 12.3613 5.23881 12.6581 5.42112 12.8419L8.35436 15.7989C8.5367 15.9827 8.8335 15.9839 9.01729 15.8015Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCalendar;
